import './sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from'react-router-dom';
import { CookiesProvider } from "react-cookie";
import './index.css'
import '../node_modules/video-react/dist/video-react.css';
import App from './App';
import RouteError from './pages/RouteError';
import Login from './pages/Login';
import DashBoard from './pages/DashBoard';
import Loading from './pages/Loading';
import SignUp from './pages/SignUp';
import SignUpCallback from './pages/SignUpCallback';
import PwInquiry from './pages/PwInquiry';
import Main from './pages/Main';
import Evnt from './pages/Evnt';
import TotWork from './pages/TotWork';
import TbmCrrStatus from './pages/TbmCrrStatus';
import Mypage from './pages/Mypage';
import Suggestions from './pages/Suggestions';
import StopRequest from './pages/StopRequest';
import Nonconformity from './pages/Nonconformity';
import CompanyEval from './pages/CompanyEval';
import SafetyCheck from './pages/SafetyCheck';
import SmartTBMList from './pages/SmartTBMList';
import SmartTBM from './pages/SmartTBM';
import TeamTBM from './pages/TeamTBM';
import DngrEval from './pages/DngrEval';
import PcSignUp from './pages/PcSignUp';

import * as envHelper from "./helper/EnvHelper";

// @ts-ignore
import TmTbmCrrStatus from "./components/tm-tbm-crr-status/TmTbmCrrStatus";
import FindPw from "./pages/FindPw";
import ForeignerDone from "./components/foreigner/ForeignerDone";
import SignUpForeigner from "./pages/SignUpForeigner";
import Foreigner from "./pages/Foreigner";



const $ = require("jquery")

const router = createBrowserRouter([
    {
      path: '/',
      element: <App />,
      errorElement: <RouteError />,
      children: [
        { index: true, path: '/', element: <Login /> },
        { path: '/dashboard', element: <DashBoard /> },
        { path: '/loading', element: <Loading /> },
        { path: '/login', element: <Login /> },
        { path: '/findPw', element: <FindPw /> },
        { path: '/foreigner', element: <Foreigner /> },
        { path: '/foreigner-done', element: <ForeignerDone /> },
        { path: '/signup-foreigner', element: <SignUpForeigner /> },
        { path: '/signUp', element: <SignUp /> },
        { path: '/signUp-callback', element: <SignUpCallback /> },
        { path: '/main', element: <Main /> },
        { path: '/event', element: <Evnt /> },
        { path: '/total-work', element: <TotWork /> },
        { path: '/tbm-current-status', element: <TbmCrrStatus /> },
        { path: '/tm-tbm-current-status', element: <TmTbmCrrStatus />},
        { path: '/smart-TBM-list', element: <SmartTBMList /> },
        { path: '/smart-TBM', element: <SmartTBM /> },
        { path: '/team-TBM', element: <TeamTBM /> },
        { path: '/danger-evaluation', element: <DngrEval /> },
        { path: '/safetyCheck', element: <SafetyCheck /> },
        { path: '/company-evaluation', element: <CompanyEval /> },
        { path: '/nonconformity', element: <Nonconformity /> },
        { path: '/sgst', element: <Suggestions /> },
        { path: '/stop-request', element: <StopRequest /> },
        { path: '/mypage', element: <Mypage /> },
        // { path: '/admin/sign-up', element: <PcSignUp /> },

        // {path: '/smrtTbmCmpnyList', element: <SmrtTbmCmpnyList />},
        // {path: '/smrtTbmList', element: <SmrtTbmList />},
        // {path: '/smrtTbmDngrEval', element: <SmrtTbmDngrEval />},
        // {path: '/smrtTbmAncmnt', element: <SmrtTbmAncmnt />},
        // {path: '/smrtTbmSftyEdu', element: <SmrtTbmSftyEdu />},
        // {path: '/smrtTbmSftyRul', element: <SmrtTbmSftyRul />},
        // {path: '/smrtTbmChkList', element: <SmrtTbmChkList />},
        // {path: '/smrtTbmDngrEvalList', element: <SmrtTbmDngrEvalList />},
        // { path: '/tmTbmDngrEval', element: <TmTbmDngrEval />},
        // { path: '/tmTbmChkList', element: <TmTbmChkList />}
        // { path: '/dngrEvalList', element: <DngrEvalList /> },
        // { path: '/dngrEvalDtl', element: <DngrEvalDtl /> },

        // {
        //   path: '/products/new',
        //   element: (
        //     <ProtectedRoute requireAdmin>
        //       <NewProduct />
        //     </ProtectedRoute>
        //   ),
        // },
        // {
        //   path: '/products/:id',
        //   element: <ProductDetail />,
        // },
        // {
        //   path: '/carts',
        //   element: (
        //     <ProtectedRoute>
        //       <MyCart />
        //     </ProtectedRoute>
        //   ),
        // },
      ],
    },
  ]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.Fragment >
    <CookiesProvider>
      <RouterProvider router={router} />
    </CookiesProvider>
  </React.Fragment >
);
